import { useEffect, useState } from 'react';
import { listDevelopers } from '@/services/alerts';
import type { Developer } from '@/types';

export function DeveloperPicker({
  value, onChange, excludeId, placeholder = 'Select a developer…',
}: {
  value: string | null;
  onChange: (id: string | null) => void;
  excludeId?: string;
  placeholder?: string;
}) {
  const [devs, setDevs] = useState<Developer[]>([]);

  useEffect(() => {
    listDevelopers().then(setDevs).catch((e) => console.error('[DeveloperPicker]', e));
  }, []);

  return (
    <select className="input" value={value ?? ''} onChange={(e) => onChange(e.target.value || null)}>
      <option value="">{placeholder}</option>
      {devs.filter((d) => d.id !== excludeId).map((d) => (
        <option key={d.id} value={d.id}>{d.display_name}</option>
      ))}
    </select>
  );
}
